export default __webpack_public_path__ + "static/media/tBTCAppBannerWithGrid.1ba64547.svg";